import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class UserNoteMiniEntity {
  id?: string
  userId?: string
  user?: UserMiniEntity
  note?: string | null
  adminUserId?: string
  adminUser?: UserMiniEntity
  createdAt?: string
  updatedAt?: string | null
}
